<template>
  <div class="flowCenter">
    <div class="box">
      <div class="container clear">
        <div class="main-left fl">
            <sidebar-page></sidebar-page>
        </div>
        <div class="main-right fl">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane class="flow tab" label="   流量任务   " name="tbTask">
            </el-tab-pane>
            <el-tab-pane class="collection tab" label="收藏任务" name="tbCollection">
              <el-form  label-width="84px"   label-position="right">
                <el-form-item label="任务类型">
                  <div class="commonTabnav">
                    <ul>
                      <li :class="type == item.type?'active':''" v-for="(item, index) in tabnav1" :key="index" @click="tabChange(item.type, item.link)">{{item.name}}</li>
                    </ul>
                  </div>
                </el-form-item>
              </el-form>
              <el-form label-width="84px" :model="formList" label-position="right">
                  <el-form-item label="" prop="link">
                      <p class="txt-red">聚划算开团提醒只能发布和完成250个任务，不保证显示率 <el-button class="txt-42aee3 cup" icon="el-icon-search" @click="centerDialogVisible=true">点击查看详细</el-button></p>
                  </el-form-item>
                  <el-form-item label="宝贝链接" prop="link">
                      <el-input v-model="formList.goodsUrl" placeholder="请输入聚划算宝贝链接" @input="changeLink" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="宝贝标题" prop="link">
                      <el-input  class="input-with-select" placeholder="标题自动获取或手动填写" v-model="formList.goodsTitle"></el-input>
                      <div class="taotask_time taotask-item" v-for="(item,keys) in keyForm" :key="keys">
                          <el-form-item label="发布量">
                              <input  class="likeInput" type="number" name=""  v-model="item.visitNum" @input="changePer(item.visitNum,keys)" >
                          </el-form-item>
                          <div class="tasktimeBox_fa">
                              <p class="tit">单日时间细分</p>
                              <div class="tasktimeBox" v-for="i in 24" :key="i">
                                  <p class="bg">{{i-1}}点</p>
                                  <input type="number" name="" min="0" v-model="item.timeSlot[i-1]"  @change="changeTime(keys,item.timeSlot[i-1],(i-1))">
                              </div>

                          </div>
                      </div>
                  </el-form-item>
                  <el-form-item label="发布天数">
                      <input  class="likeInput mini" type="number" name="" @input="changeDay2(formList.numberDays)"  v-model="formList.numberDays" oninput="this.value=this.value.replace(/\D/g,'').replace(/^0+(?=\d)/,'')">
                      <span class="mr10">天</span>
                      <div class="in-block">
                          <span class="commButton" :class="dayStyle==days?'active':''" v-for="(item,days) in btlist" :key="days" @click="changeDay(item,days)" >{{item}}天</span></div>
                  </el-form-item>

                  <el-form-item label="开始时间">
                      <el-date-picker
                      v-model="formList.startDate"
                      type="date"
                      :editable="false"
                      placeholder="选择日期"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions0"

                      >
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                      <div v-show="busType">
                          <el-button class="btn-search mt20" type="primary" :loading="loading" @click="goRelease">
                              <span v-if="!loading">点击发布</span>
                              <span v-else>正在发布...</span>
                          </el-button>
                          <el-button @click="needReload">取消</el-button>
                      </div>
                      <div class="commTs" >
                          <p>
                              任务时长
                              <span> {{formList.numberDays}}</span>
                              天，共计发布 <span>{{taskCount}} </span>
                              个任务，共消耗条数为<span>{{taskNumber}}</span>
                              条
                          </p>
                      </div>
                  </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane class="add tab" label="加购任务" name="tbAdd"></el-tab-pane>
            <el-tab-pane class="wangwang tab" label="旺旺打标" name="wangwang"></el-tab-pane>
            <el-tab-pane class="linkes tab" label="宝贝点赞" name="linkes"></el-tab-pane>
            <el-tab-pane class="guangguang tab" label="逛逛点赞" name="guangguang"></el-tab-pane>
            <!-- <el-tab-pane class="tbLive tab" label="淘宝直播" name="tbLive"></el-tab-pane> -->
            <!-- <el-tab-pane class="dayGood tab" label="每日好店" name="tbDayGood"></el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
      <el-dialog
        title="聚划算开团提醒"
        :visible.sync="centerDialogVisible"
        width="900px"
        center>
        <div class="tip-warning">
          <p>想要发布开团提醒的会员，请务必全文看完，没看完的会员，造成的任何问题，概不负责！</p>
        </div>
        <div class="modal-body">
            <p>聚划算一直会产生<b class="txt-red">严重掉量</b>的情况，发布请务必注意<b class="txt-red">计算成本</b>！尤其是代理，以免亏损！</p>
            <p><b class="txt-red">不足量的积分是无法退的</b>。请务必务必务必先小规模发布试试淘宝是否坑爹再决定是否大面积发布！我们测试的完成率只针对测试当天的结果，每天的结果是不一样的，完成率无法保证，<b class="txt-red">能接受的才发布</b>！</p>
            <p>1，发布250个以下的任务（初值粉丝要为0，其他情况也类似，如果已经有几十个或者几百个粉丝，你再来刷，能显示出来的，就得参照2条），相对显示率较高，可能在90%；——<b class="txt-red">当然也可能几乎不显示，务必自己测试先</b>！</p>
            <p>2，超过250个，很大概率会被屏蔽。——<b class="txt-red">比较坑爹，不建议接超过250个的任务！除非你单价卖得够高</b>！</p>
            <p><b class="txt-red">万一出现不够量的积分不退不补，没完成的量可以追减退还积分，不足量的不补分，请自行决 定是否发布任务哦！</b>
            </p>
            <p> </p>
            <p><b class="txt-red">由于淘宝改版，一个小号一天只能接10个，速度明显变慢，成本十分 高，您可以用自己实名认证的小号去点聚划算，然后刷新页面，有时候是可以增加一个购买的粉丝的，有时候就不显示。也就是不够量的原因实际上很简单，就是淘宝的限制太严格了。导致同样符合条件的小号去点聚划算，有时候可以完成任务，有时候就不显示，被淘宝暂时隐藏，这个目前技术是没有任何办法的，因此请如果是帮别人发布任务的代理商务必注意。</b>
            </p>
            <p> </p>
            <p><b class="txt-red">有些链接发布会显示错误，无法获取信息的</b>，注意以下方法：要从<a href="https://ju.taobao.com/" target="_blank">https://ju.taobao.com/</a>首页访问，往下拉页面，看到如下图的搜索框：</p>
            <p class="txt-center">
                <img alt="如何提升聚划算开团提醒粉丝数量(17.8.28最新屏蔽通告）" src="http://mapp.alicdn.com/1509685965861CcGB5PNIBqz0DH0.jpg" style="border: 1px solid #ccc; max-width: 66%; margin: 20px auto;">
            </p>
            <p>去搜索下你要发布的这个商品的全称，点击进去，再用打开的新链接来发布即可。</p>
            <p>比如：“[MaxMartin/玛玛绨]亮片刺绣繁复工艺棒球服时尚外套（每个ID限购5件）”你只要搜索“亮片刺绣繁复工艺棒球服时尚外套”就可以找到啦。</p>
            <p> </p>
            <p>在此处，有个开团提醒，当你点进去之后，会出现让你可以填写旺旺号等选项，时间一到就可以提前通知到客户。</p>
            <p class="txt-center">
                <img alt="如何提升聚划算开团提醒粉丝数量(17.8.28最新屏蔽通告）" src="http://mapp.alicdn.com/1509686386750Fb0pyPS8VrOoDgp.jpg" style="border: 1px solid #ccc; max-width: 66%; margin: 20px auto;">
            </p>
            <p>猎流新增加这个功能，比如上图，如果是“590人想买”，那么大部分买家都有从众心理，肯定觉得这个商品特别好，有些还在犹豫的买家很可能一下子就也提交了开团提醒，并在第二天进行了商品购买。可以说，是真正能够增加收入的一大捷径哦！</p>
            <p> </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import sidebarPage from '../../components/sidebar'
import $ from 'jquery'
import http from '../../axios'
// import { getUUID, clearLoginInfo } from '@/utils'
export default {
  inject: ['reload'],
  components: {
    sidebarPage
  },
  data () {
    return {
      centerDialogVisible: false,
      loading: false,
      busType: true,
      activeName: 'tbCollection',
      type: 4,
      dayStyle: -1,
      extUsedCoefficient2: '0',
      taskCount: 100, // 总任务量
      taskNumber: 100, // 总任务条数
      tabnav1: [{
        name: '搜索收藏',
        type: 1,
        link: '/tbCollection'
      },
      {
        name: '商品收藏',
        type: 2,
        link: '/tbGoodCollection'
      },
      {
        name: '店铺收藏',
        type: 3,
        link: '/tbShopCollection'
      },
      {
        name: '聚划算',
        type: 4,
        link: '/tbJuhuasuan'
      }],
      keyForm: [{
        keyword: '',
        visitNum: 100,
        timeSlot: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        showNum: 0,
        click: 0,
        myClick: 1
      }],
      btlist: ['7', '15', '30'],
      Proportion: [0.03, 0.03, 0.03, 0.03, 0.03, 0.03, 0.03, 0.02, 0.02, 0.05, 0.05, 0.07, 0.05, 0.05, 0.05, 0.07, 0.05, 0.05, 0.05, 0.05, 0.07, 0.05, 0.02, 0.02],
      formList: {
        compareOther: 'N', // 货比三家
        lookDetail: 'N', // 浏览详情
        lookEvaluation: 'N', // 浏览评价
        platformType: '', // 平台类型
        flowType: '', // 流量类型
        goodsTitle: '', // 商品标题
        goodsUrl: '', // 商品链接
        startDate: '', // 开始时间
        showCount: 0, // 展现数量
        visitorCount: 0, // 访客数量
        numberDays: 1, // 发布天数
        extUsedCoefficient: '0', // 额外消耗总额
        taskListSubs: []

      },
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  created () {
    let _this = this
    // 获取当前小时
    let myDate = new Date()
    let hours = Number(myDate.getHours())
    // 获取点数分配
    let allnum = 100
    let sun = []
    let sunmu = 0
    for (let i = hours; i < 24; i++) {
      sun[i] = allnum * _this.Proportion[i]
      sunmu = sun[i] + sunmu
    }
    let aa = (allnum - sunmu) / (24 - hours)
    sunmu = 0
    for (let i = hours; i < 24; i++) {
      sun[i] = Math.floor(sun[i] + aa)
      sunmu = sun[i] + sunmu
    }
    let lastnum = allnum - sunmu
    if (lastnum < 0) {
      lastnum = Math.abs(lastnum)
      for (let i = 23; i >= hours; i--) {
        if (lastnum > 0) {
          if (sun[i] >= 1) {
            sun[i] = sun[i] - 1
            lastnum--
          }
        }
      }
    } else if (lastnum > 0) {
      sun.forEach((item, index) => {
        if (lastnum > 0) {
          sun[index] = item + 1
          lastnum--
        }
      })
    }
    for (let i = 0; i < 24; i++) {
      if (i < hours) {
        _this.$set(_this.keyForm[0].timeSlot, i, 0)
      } else {
        _this.$set(_this.keyForm[0].timeSlot, i, sun[i])
      }
    }
  },
  methods: {
    needReload () {
      this.reload()
    },
    handleClick (tab, event) {
      this.$router.push({path: '/'+tab.name})
    },
    changeDay (day, id) {
      let _this = this
      _this.dayStyle = id
      _this.formList.numberDays = day
      _this.countAll()
    },
    tabChange (index, link) {
      this.type = index
      this.$router.push({path: link})
    },
    // 时间点数改变访客数也变化
    changeTime (num, val, index) {
      let _this = this
      let res = /^[1-9]+[0-9]*]*$/
      if (!res.test(val)) {
        // _this.$message({
        //   type: 'warning',
        //   message: '请输入纯数字！'
        // })
        _this.$set(_this.keyForm[num].timeSlot, index, 0)
        _this.countAll()
        // return
      }
      if (val === '') {
        _this.$set(_this.keyForm[num].timeSlot, index, 0)
      }
      let sum = 0
      _this.keyForm[num].timeSlot.forEach((item) => {
        sum += Number(item)
      })
      // 返回
      _this.keyForm[num].visitNum = sum

      _this.countAll()
    },
    // 访客数改变时间点重新分配
    changePer (allcount, list) {
      let _this = this
      let res = /^[0-9]+[0-9]*]*$/
      if (!res.test(allcount)) {
        _this.$message({
          type: 'warning',
          message: '请输入不能少于1的纯数字！'
        })
        _this.$set(_this.keyForm[list], 'visitNum', '')
        allcount = 1
      }

      if (allcount === '' || Number(allcount) > 1000000 || allcount === '0') {
        _this.$message({
          type: 'warning',
          message: '每天访客数不能少于1或者大于100万'
        })
        _this.$set(_this.keyForm[list], 'visitNum', '')
        allcount = 1
      }
      let myDate = new Date()
      let hours = Number(myDate.getHours())
      // 获取点数分配
      let allnum = Number(allcount)
      let sun = []
      let sunmu = 0
      for (let i = hours; i < 24; i++) {
        sun[i] = allnum * _this.Proportion[i]
        sunmu = sun[i] + sunmu
      }
      let aa = (allnum - sunmu) / (24 - hours)
      sunmu = 0
      for (let i = hours; i < 24; i++) {
        sun[i] = Math.round(sun[i] + aa)
        sunmu = sun[i] + sunmu
      }
      let lastnum = allnum - sunmu
      if (lastnum < 0) {
        lastnum = Math.abs(lastnum)
        for (let i = 23; i >= hours; i--) {
          if (lastnum > 0) {
            if (sun[i] >= 1) {
              sun[i] = sun[i] - 1
              lastnum--
            }
          }
        }
      } else if (lastnum > 0) {
        sun.forEach((item, index) => {
          if (lastnum > 0) {
            sun[index] = item + 1
            lastnum--
          }
        })
      }
      for (let i = 0; i < 24; i++) {
        if (i < hours) {
          _this.$set(_this.keyForm[list].timeSlot, i, 0)
        } else {
          _this.$set(_this.keyForm[list].timeSlot, i, sun[i])
        }
      }
      _this.countAll()
    },
    // 更改发布天数
    changeDay2 (day) {
      let _this = this
      let days = Number(day)
      if (days === '' || days <= 0) {
        _this.$message({
          type: 'warning',
          message: '天数不能小于1'
        })
        _this.$set(_this.formList, 'numberDays', '')
      } else if (days === 7) {
        _this.dayStyle = 0
      } else if (days === 15) {
        _this.dayStyle = 1
      } else if (days === 30) {
        _this.dayStyle = 2
      } else {
        _this.dayStyle = -1
      }
      _this.countAll()
    },
    // 计算总和
    countAll () {
      let _this = this
      // 计算任务
      let sumtas = 0
      _this.keyForm.forEach((item) => {
        let sumtask = item.visitNum
        sumtas += Number(sumtask)
      })
      _this.taskCount = sumtas * (Number(_this.formList.numberDays))
      let tlTime = Number(_this.formList.extUsedCoefficient)
      let tlTime2 = Number(_this.extUsedCoefficient2)
      _this.taskNumber = Math.round((sumtas * (1 + tlTime + tlTime2))) * (Number(_this.formList.numberDays))
    },
    // 发布任务
    goRelease () {
      let _this = this
      if (_this.formList.goodsUrl === '') {
        _this.$message({
          type: 'warning',
          message: '请输入宝贝链接'
        })
      } else if (_this.formList.goodsTitle === '') {
        _this.$message({
          type: 'warning',
          message: '宝贝标题不能为空'
        })
      } else if (_this.keyForm[0].visitorCount === '' || Number(_this.keyForm[0].visitorCount) < 1) {
        _this.$message({
          type: 'warning',
          message: '发布量必须大于1'
        })
      } else {
        _this.goRelease2()
      }
    },
    goRelease2 () {
      let _this = this
      if (!localStorage.getItem('info')) {
        this.$message({
          type: 'warning',
          message: '请登录后使用'
        })
        this.$router.push({path: '/login'})
        return
      }
      if (_this.keyForm[0].visitNum === '' || _this.keyForm[0].visitNum === 0 || _this.keyForm[0].visitNum === '0') {
        _this.$message({
          type: 'warning',
          message: '发布量不能小于1'
        })
        return
      }
      if (_this.formList.numberDays === '' || _this.formList.numberDays <= 0) {
        _this.$message({
          type: 'warning',
          message: '天数不能小于1'
        })
        return
      }
      // 深拷贝一组keyForm
      let arr = _this.keyForm.map(o => ({...o}))
      arr.forEach((item, index) => {
        let sumtask2 = item.timeSlot
        item.timeSlot = sumtask2.join(',')
        item.click = _this.formList.numberDays * Number(_this.keyForm[index].visitNum)
      })
      _this.formList.taskListSubs = arr
      // let arr2 = JSON.parse(JSON.stringify(_this.formList))
      _this.loading = true

      let dataTime = new Date()
      let dataTimeFull = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate()
      let newTime = dataTimeFull.replace(/[-]/g,"")
      let oldTime = _this.formList.startDate.replace(/[-]/g,"")
      if (parseInt(oldTime) < parseInt(newTime)) {
        _this.formList.startDate = dataTimeFull
      }
      const params = {
        clickRation: '0', // 浏览其他宝贝 0=不浏览 1=随机浏览 2=深度浏览
        endTime: _this.formList.startDate,
        keyList: _this.formList.taskListSubs, // 关键词列表 ,
        hoverTime: '100-180',
        module: 12,
        money: _this.taskNumber,
        platform: 1,
        remark: '',
        rwzl: _this.formList.numberDays,
        startTime: _this.formList.startDate, // 任务开始时间
        taskTotal: _this.taskCount, // 发布任务总量 任务总量必须等于 每天任务量*任务的执行天数 ,
        title: _this.formList.goodsTitle,
        url: _this.formList.goodsUrl
      }
      try {
        http.taobaoHot(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:

              _this.$message({
                message: '发布成功',
                type: 'success'
              })
              _this.reload()
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    changeLink () {
      let _this = this
      var badyLinkID
      this.formList.goodsTitle = ''
      if (!localStorage.getItem('token')) {
        _this.$router.push({path: '/login'})
        return
      }

      if (this.formList.goodsUrl.startsWith('http') && this.formList.goodsUrl.indexOf('ju.') !== -1) {
        
        badyLinkID = this.getIdFromUrl(this.formList.goodsUrl)
      } else {
        this.$message.info('请输入正确的聚划算链接')
        return
      }
      _this.ajaxTB(badyLinkID)
      
    },
    getIdFromUrl (url) {
      let res = {}
      let idMatchRes = url.match(/(\?|&)item_id=\d+/)
      let matchRes
      if (idMatchRes) {
        matchRes = idMatchRes[0].match(/\d+/g)
      }
      if (matchRes) {
        res = matchRes[0]
      }
      return res
    },
    ajaxTB (badyLinkID) {
      let _this = this
      let params = {
        url: this.formList.goodsUrl
      }
      try {
        http.newGetgoodsTitle(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:
              _this.formList.goodsTitle = data.data.title
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    }
  },
  mounted () {
    // 设置默认消耗参数
    let _this = this
    _this.formList.platformType = _this.$route.meta.title
    _this.formList.flowType = _this.$route.meta.title2
    let myDate = new Date()
    let myDateFull = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate()
    _this.formList.startDate = myDateFull
    if (_this.$route.params.busininfo !== undefined) {
      let info = JSON.parse(this.$route.params.busininfo)
      info.keyList.forEach((item, index) => {
        item.timeSlot = item.timeSlot.split(',')
      })
      _this.keyForm = info.keyList
      _this.formList.goodsUrl = info.url
      _this.formList.goodsTitle = info.title
      _this.taskCount = info.taskTotal
      _this.taskNumber = info.money
      _this.formList.startDate = info.startTime
      _this.countAll()
    }
  }
}
</script>
<style lang="less" scoped>
.btn_li {
    float: left;
    display: block;
    line-height: 1;
    white-space: nowrap;
    background: #fff;
    border: 1px solid #dcdfe6;
    font-weight: 500;
    border-left: 0;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    cursor: pointer;
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 0;
}
.container {
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    border-radius:5px;
    width: 1200px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    .main-left {
        width: 15%;
    }
    .main-right {
        width: 85%;
        padding: 15px 56px 27px;
        box-sizing: border-box;
        /deep/ .el-tabs__item {
            width: 103px !important;
            padding: 0;
            text-align: center;
            font-size: 18px;
            color: #333333;
        }
        /deep/ .el-tabs__item.is-active,
        /deep/ .el-tabs__item:hover {
            color: #FC6B0E;
        }
        /deep/ .el-tabs__active-bar {
            background: #FC6B0E;
        }
        .commonTabnav {
            ul {
                font-size: 0;
                border-left: 1px solid #dcdfe6;
                border-radius: 3px;
                overflow: hidden;
                li {
                    .btn_li();
                }
                li:first-child {
                    border-radius: 3px 0 0 3px;
                }
                li:last-child {
                    border-radius: 0 3px 3px 0;
                }
                .active {
                    background-color: #fc6b0e;
                    border-color: #fc6b0e;
                    color: #fff;
                }
            }
        }
        /deep/ .el-form-item__content {
            margin-left: 102px !important;
        }
        .taotask_time {
            border: 2px solid #fc6b0e;
            background-color: #fef0e7;
            margin: 15px 0;
            padding-right: 20px;
            position: relative;
            padding-top: 10px;
            .likeInput {
                -webkit-appearance: none;
                background-color: #fff;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #d4d4d4;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                font-size: inherit;
                height: 40px;
                line-height: 40px;
                outline: 0;
                padding: 0 15px;
                -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                width: 100%;
            }
            /deep/ .el-form-item {
                margin-bottom: 22px;
            }
            .dialogTbaoText{
                line-height: 24px;
            }
            .tasktimeBox input::-webkit-outer-spin-button,.tasktimeBox input::-webkit-inner-spin-button{
                -webkit-appearance: none !important;
                margin: 0;
            }
            .el-date-editor .el-input__suffix{
                display: none;
            }
            body .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #fc6b0e;
            }
            .tasktimeBox_fa {
                padding: 0 0 0 34px;
                .tit {
                    color: #666;
                    font-size: 12px;
                }
                .tasktimeBox {
                    display: inline-block;
                    margin-right: 2px;
                    border-radius: 10px;
                    overflow: hidden;
                    text-align: center;
                    width: 40px;
                    border: 1px solid #fc6b0e;
                    p {
                        line-height: 22px;
                    }
                    .bg {
                        background-color: #fc6b0e;
                        color: #fff;
                    }
                    input {
                        margin: 0;
                        width: 100%;
                        border: 0;
                        background-color: transparent;
                        text-align: center;
                        display: block;
                        line-height: 24px;
                        color: #fc6b0e;
                    }

                }
            }

        }
        .likeInput {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            padding: 0 15px;
            -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            width: 100%;
        }
        .mini {
            width: 200px;
            display: inline-block;
        }
        .in-block {
          float: right;
          .commButton {
            display: inline-block;
            text-align: center;
            border-radius: 3px;
            min-width: 76px;
            height: 35px;
            padding: 0 15px;
            line-height: 35px;
            color: #fc6b0e;
            border: 1px solid #fc6b0e;
            margin-left: 10px;
            cursor: pointer;
          }
          .active {
            background-color: #fc6b0e;
            color: #fff;
          }
        }
        /deep/ .el-checkbox__label {
            color: #fc6b0e;
        }
        /deep/ .is-checked{
            /deep/ .el-checkbox__inner {
                border-color: #fc6b0e;
                background: #fc6b0e;
            }

        }
        /deep/ .el-button:focus {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button:hover {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button--primary {
            background-color: #fc6b0e;
            border-color: #fc6b0e;
        }
        /deep/ .el-button--primary:hover{
            background-color: #fd863a;
            border-color: #fd863a;
            color: #fff;
        }
        .commTs {
            font-size: 12px;
            color: #666;
            span {
                color: #ff1e00;
                font-size: 14px;
            }
        }
    }
}
.tip-warning {
  border-color: #f0ad4e;
  background: #fcf8e3;
  margin: 0 0 20px 0;
  padding: 15px 30px 15px 15px;
  border-left: 3px solid #cccccc;
  border-radius: 0 !important;
      text-align: center;
}
.modal-body {
  padding: 40px 40px 20px 40px;
  background-color: #ffffff;
  p {
    margin: 0 0 10px;
    line-height: 1.42857143;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/tbJuhuasuan/tbJuhuasuan.vue